
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { TokenIcon } from '../../ui/ChainIcons';

export const MainnetValidation: React.FC = () => {
    return (
        <div className="p-4 bg-stone-50/50 dark:bg-black/20 border-t border-stone-100 dark:border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4 shrink-0">
            <div className="flex items-center gap-3">
                <div className="flex -space-x-2">
                    <TokenIcon symbol="SOL" className="w-5 h-5 rounded-full border border-white dark:border-black" />
                    <TokenIcon symbol="SUI" className="w-5 h-5 rounded-full border border-white dark:border-black" />
                    <TokenIcon symbol="USDC" className="w-5 h-5 rounded-full border border-white dark:border-black" />
                </div>
                <span className="text-[9px] font-black text-stone-500 uppercase tracking-[0.2em]">Network Status</span>
            </div>
            <div className="flex items-center gap-3">
                <div className="flex items-center gap-1.5 px-2 py-0.5 rounded bg-emerald-500/10 border border-emerald-500/20">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                    <span className="text-[8px] font-mono font-bold text-emerald-600 dark:text-emerald-400 uppercase tracking-widest">Online</span>
                </div>
                <span className="text-[9px] font-mono text-stone-400 font-bold uppercase">Sync: 12ms</span>
            </div>
        </div>
    );
};
